import { render, staticRenderFns } from "./MzData.vue?vue&type=template&id=b2c87bd4&"
import script from "./MzData.vue?vue&type=script&lang=js&"
export * from "./MzData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports